<template>
  <div class="payment-wrap">
    <Refund v-if="status === STATUS.REFUND" />
    <div v-else class="c-page-pay">
      <Dialog title="家长代付" v-if="familyModal" @close="familyModal = false">
        <div class="modal-wechat">
          <p class="color-17181A fs-16 lh-24 sybold">
            复制并通过微信分享给你的父母<br />
            <span class="color-377ECF fs-16 lh-24 sybold">{{ guestPayLink }}</span>
            <br />
            支付完成后，请刷新页面
          </p>
        </div>
        <div class="copy-wrap mt-40 J-click-copy" @click="handleClickCopy" :data-clipboard-text="guestPayLink">
          <Button skin="red">复制</Button>
        </div>
      </Dialog>
      <Dialog title="微信支付" v-if="weChatModal" @close="closeWeChatModal">
        <div class="modal-wechat">
          <Qr className="img-qr" :text="qr" :size="130" />
          <div class="pay-message">
            <p class="color-17181A fs-16 lh-24 sybold">如何支付</p>
            <p class="pt-10 color-494A4D fs-14 lh-21 synormal pc-only">进入微信“扫一扫”扫描二维码后支付</p>
            <p class="pt-10 color-494A4D fs-14 lh-21 synormal m-only">请长按保存左侧二维码后，进入微信“扫一扫”，并从相册选取次二维码图片后支付。</p>
          </div>
        </div>
      </Dialog>
      <Dialog title="支付" v-if="aliModal" @close="closeAliModal">
        <div class="modal-ali">
          <Button className="item" skin="black" @click="closeAliModal">遇到问题 重新付款</Button>
          <Button className="item" skin="red" @click="handleClickSuccess">已完成支付</Button>
        </div>
      </Dialog>
      <div class="page-content">
        <h1 class="page-title sybold color-17181A fs-24 lh-36">支付项目部分费用，确认席位</h1>
        <br />
        <div class="font16 syNormal desc">
          祝贺你已经获得2022年HSYLC的录取，请于
          <span class="color-A11A22 sybold">北京时间 {{ time7 }} 晚23:59前</span>
          缴纳HSYLC项目费用，以正式锁定2022峰会的学生席位，开始浏览2022年峰会正式哈佛seminar列表，并开始进行进行参与日期选择、学习计划、选课等一系列峰会前准备。HSYLC申请竞争激烈，逾期将视作放弃席位，录取委员会将把席位给予尚处于等候名单waiting
          list上的其他同学。
        </div>
        <h2 class="h2 color-gray-1 mt-20">选择支付方式</h2>
        <PayChannel class="mt-10" :value="channel" :family="true" :channels="channels" @input="handleChannelInput" />
        <!-- 必选 -->
        <div class="checkBox-line font16 syNormal marginTop30 " @click="handleConfirm">
          <div class="tick-wrap" :class="isConfirm ? 'active' : ''">
            <Tick class="icon" :color="tickColor" />
          </div>
          <div class="text-wrap">
            勾选此条表示你已同意《HSYLC哈佛HSYLC峰会学生须知及退费政策》<br />
            <span class="color-A11A22 sybold" data-pageName="pay-admission-notices" @click="handleGoToPage">点击查看退费政策</span>
          </div>
        </div>
        <h2 class="h2 color-gray-1 mt-30">2022年HSYLC 费用包括</h2>
        <p class="mt-10 text1">
          <span class="bold color-gray-1">项目费用：</span>
          <span class="bold color-red-default">总计9,800元（约1,480美元）</span>
          <span class="color-gray-3"> 确认席位时缴纳</span>
        </p>
        <p class="text1 color-gray-2 mt-10">
          费用包括：峰会开始前官网先导课程和学习资料、纸质暑期阅读和实体预习资料、暑期线上预习和先导讲座、峰会官网选课、排课等管理系统、营服文具等系列周边包裹；哈佛商学院等世界名校学术资料版权使用、峰会期间来自哈佛等国内外名校学者实时亲授小班seminar研讨全部师资和课程研发、跨国技术平台开发使用和独家活动等。
        </p>
        <!-- <p class="text1 mt-20">
          <span class="bold color-gray-1">线下场食宿及活动费用：</span>
          <span class="bold color-red-default">总计2,000元（约302美元）</span>
          <span class="color-gray-3"> 6月初选定线下会场后缴纳</span>
        </p>
        <p class="text1 color-gray-2 mt-10">
          包含：峰会举办9天期间设施使用、宿舍、用餐及相应场地供应和管理、安保清洁及配套人员、学习活动材料和用具、保险等费用，总计2,000元。
          <span class="bold color-gray-1">目前你还不需要缴纳这一部分费用，</span>
          在6月初最终选定会场和时间场次时，如果确定线下场再进行缴纳即可。
        </p> -->
        <h2 class="h2 color-gray-1 mt-30">助学金申请</h2>
        <p class="text1 color-gray-2 mt-10">
          和哈佛大学的本科录取政策一样，HSYLC从举办第一天起设置100% Need-blind“无条件助学金Financial
          Aid制度，确保让每个足够优秀被录取的学生，都同等拥有在这里让梦想启航的机会。根据学生在截止日期前提交的家庭经济困难情况证明材料和学校证明，组委会将基于困难程度发放返还不同额度的助学金，最高实现全额减免。助学金申请截止日期与你的峰会申请截止日期相同，如果你因为特殊原因错过了助学金申请截止日期，请发邮件询问助学金工作组
          <a href="mailto:financial.aid@hsylc.cn" class="link bold color-red-default">financial.aid@hsylc.cn</a>
          ，说明特殊情况。
        </p>
        <!-- <p class="h3 color-gray-1 mt-20">选择参与日期并完成项目费用9,800元支付</p> -->
        <Button class="mt-20 btn-scholar" skin="grey" @click="$windowOpen('/apply/financial-aid')" v-if="!$store.state.isAMCSite">申请助学金</Button>
        <!-- <div class="color-7C7D80 font16 syNormal marginTop10">成功被峰会录取的同学，之前交的90元申请费会自动抵扣费用。</div>
        <div class="color-E61717 font16 syNormal marginTop10" v-if="isOver">
          <strong>你未在组委会指定日期内完成费用支付，默认为放弃峰会学生资格。如有问题请联系组委会。</strong>
        </div> -->
        <div class="marginBottom100"></div>

        <!-- <p class="pay-tip synormal mt-10 color-7C7D80 fs-12 lh-16">
          线下报名码仅在HSYLC校友推荐、学校推荐等活动中发放，详情请关注微信公众号“哈佛HSYLC峰会”，或询问邮箱apply@hsylc.cn。如果你正在争取推荐名额，我们建议你先提交申请费，这将使你的申请材料率先进入组委会的审核流程。在拿到校友或学校的推荐名额后，可写邮件至apply@hsylc.cn申请退费。
        </p> -->
      </div>
      <div class="pay-footer">
        <div class="footer-content">
          <div class="left-wrap">
            <div class="pay-info">
              <div class="gift-wrap"></div>
              <div class="info-wrap">
                <h3 class="h3 color-gray-1">确认席位即可解锁<br class="m-only" />25年哈佛小班研讨课列表</h3>
                <!-- <p class="price mt-3 text2 color-gray-3">
                  学费：
                  <span class="color-red-default bold">¥{{ payPrice }}</span>
                </p> -->
              </div>
            </div>
          </div>
          <div class="right-wrap">
            <Button className="btn-pay" skin="red" :customStyle="{ height: '100%' }" v-if="status === STATUS.PAY && !isOver && feeData" @click="handleClickPay">
              <p class="step-text text2">STEP 2/2</p>
              <p class="pay-text">付款</p>
            </Button>
            <Button className="btn-pay" disabled :customStyle="{ height: '100%' }" v-else-if="!feeData">付款</Button>
            <Button className="btn-pay" disabled :customStyle="{ height: '100%' }" v-else-if="isOver">超过支付日期</Button>
            <Button className="btn-pay" disabled :customStyle="{ height: '100%' }" v-else-if="status === STATUS.PAID">已付款</Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import './index.less';
import Clipboard from 'clipboard';
import { Button } from '../../../../components/form';
import Tick from '../../../../components/icons/Tick';
import PayChannel from '../../../../components/PayChannel';
import CHANNEL from '../../../../components/PayChannel/channel';
import { Api, Codes } from '@/api';
import Payment from '../../../../utils/pay';
import Moment from 'moment';
import { Message } from 'element-ui';
import STU_TYPE from '../../../../utils/stuType';
import { getRequest } from '../../../../utils/string';
import moment from 'moment';

//支付状态 1 未支付 2 已支付 3 退款
const STATUS = {
  PAY: 1,
  PAID: 2,
  REFUND: 3
};
export default {
  name: 'Pay',
  components: {
    Dialog: () => import('../../../../components/Dialog'),
    Qr: () => import('vue-qr'),
    Refund: () => import('./Refund'),
    Button,
    PayChannel,
    Tick
  },
  computed: {
    radioDisabled() {
      return this.isOver || !this.feeData || this.status === STATUS.PAID;
    },
    CHANNEL() {
      return CHANNEL;
    },
    stuType() {
      let ret = 0;
      if (this.feeData) {
        ret = this.feeData.active_type;
      }
      return ret;
    },
    channels() {
      let ret = ['WX', 'AL'];
      // if (this.feeData) {
      //   ret = this.feeData.channels;
      // }

      return ret;
    },
    ebDate() {
      let ret = '';
      let feeData = this.feeData;
      if (feeData && feeData.deadlines && !!feeData.deadlines.eb) {
        let eb = feeData.deadlines.eb;
        ret = Moment(eb).format('YYYY年M月D日');
      }
      return ret;
    },
    rdDate() {
      let ret = '';
      let feeData = this.feeData;
      if (feeData && feeData.deadlines && !!feeData.deadlines.rd) {
        let rd = feeData.deadlines.rd;
        ret = Moment(rd).format('YYYY年M月D日');
      }
      return ret;
    },
    price() {
      let ret = 0;
      if (this.order) {
        ret = this.order.fee;
      }
      return ret;
    },
    STATUS() {
      return STATUS;
    },
    status() {
      return this.order ? this.order.status : STATUS.PAY;
    },
    payPrice() {
      return this.channel === CHANNEL.SDL ? 0 : this.price;
    },
    STU_TYPE() {
      return STU_TYPE;
    },
    // 勾选 颜色
    tickColor() {
      let color = this.isConfirm ? '#fff' : '#E6E6E6';
      return color;
    },
    guestPay() {
      let ret = false;
      if (this.guestPayToken) {
        ret = true;
      }
      return ret;
    },
    guestPayLink() {
      let origin = window.location.origin;
      let ret = origin + '/pay/admission-parent/';
      if (this.guestPay) {
        ret += this.guestPayToken;
      }
      return ret;
    }
  },
  data: () => ({
    time7: '', // 用户 createAt + 7 时间
    signCodeModal: false,
    signCode: '',
    weChatModal: false,
    aliModal: false,
    channel: '',
    feeData: null, // 订单 信息
    payment: null,
    order: null,
    qr: '',
    isCodeLegal: false,
    Time: null,
    isOver: false, //  是否结束
    paid: false,
    init: false,
    familyModal: false,
    guestPayToken: null,
    isConfirm: false // 是否同意退费政策
  }),
  async created() {
    // 判断用户资格
    await this.$initStuRedirect();
  },
  mounted: async function() {
    this.$loading.show();
    let feeData = await Api.post.getStuTuitionFee();
    if (feeData.status === Codes.SUCCESS) {
      this.feeData = feeData.data;
      if (this.feeData.order) {
        this.order = this.feeData.order;
      }
      if (this.feeData.guest_pay_token && this.feeData.guest_pay_token !== '') {
        this.guestPayToken = this.feeData.guest_pay_token;
      }
      this.isOver = this.$time.isOverDate(feeData.data.deadlines.pay_deadline);
      // this.init = true;
      let query = getRequest();
      if (!query.hasRefresh && this.order?.status === STATUS.PAID) {
        setTimeout(() => {
          window.location.href = '/pay/admission?hasRefresh=true';
        }, 1000);
      }
      if (query.wxmp && !this.paid) {
        this.channel = CHANNEL.WX;
        await this.handleStartPay();
      }
    } else if (feeData.msg) {
      Message({
        type: 'error',
        message: feeData.msg
      });
    }

    this.$loading.hide();
    // 计算时间
    this.initTime();
    // 加载字体
    this.$nextTick(() => {
      this.$mountedRob();
    });
  },
  methods: {
    async setFeeData() {
      this.$loading.show();
      let feeData = await Api.post.getStuTuitionFee();
      if (feeData.status === Codes.SUCCESS) {
        this.feeData = feeData.data;
        if (this.feeData.order) {
          this.order = this.feeData.order;
        }
        if (this.feeData.guest_pay_token && this.feeData.guest_pay_token !== '') {
          this.guestPayToken = this.feeData.guest_pay_token;
        }
        this.isOver = this.$time.isOverDate(feeData.data.deadlines.pay_deadline);
        // this.init = true;
        // let query = getRequest();
        // if (!query.hasRefresh && this.order?.status === STATUS.PAID) {
        //   setTimeout(() => {
        //     window.location.href = '/pay/admission?hasRefresh=true';
        //   }, 1000);
        // }
        // if (query.wxmp && !this.paid) {
        //   this.channel = CHANNEL.WX;
        //   await this.handleStartPay();
        // }
      } else if (feeData.msg) {
        Message({
          type: 'error',
          message: feeData.msg
        });
      }

      this.$loading.hide();
      // 计算时间
      this.initTime();
      // 加载字体
      this.$nextTick(() => {
        this.$mountedRob();
      });
    },
    handleClickCopy: function() {
      let clipboard = new Clipboard('.J-click-copy');
      clipboard.on('success', e => {
        Message({
          type: 'success',
          message: '复制成功'
        });
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on('error', e => {
        Message({
          type: 'error',
          message: '该浏览器不支持自动复制'
        });
        // 不支持复制
        console.log('该浏览器不支持自动复制');
        // 释放内存
        clipboard.destroy();
      });
    },
    // 初始化 时间
    async initTime() {
      const FORMAT = 'YYYY年MM月DD日';
      let deadline = this.feeData?.deadlines?.deadline;
      if (deadline && deadline !== '') {
        this.time7 = moment(deadline).format(FORMAT);
      } else {
        let result = await Api.get.getStuOfferLetter();
        if (result.status === Codes.SUCCESS && result.data) {
          let createAt = moment(result.data.offer_letter.created_at).format('YYYY-MM-DD');
          let add7Num = 5;
          // let diff = moment(createAt).diff(moment('2021-06-21'));
          // console.log(diff);
          // if (diff >= 0) {
          //   add7Num = 5;
          // }
          let time7 = moment(createAt)
            .add(add7Num, 'd')
            .format(FORMAT);
          this.time7 = time7;
        }
      }
    },
    // 跳转页面
    handleGoToPage(e) {
      let pageName = e.target.dataset.pagename;

      let routeData = this.$router.resolve({
        name: pageName
      });
      this.$windowOpen(routeData.href);
    },
    // 勾选 必填
    handleConfirm() {
      this.isConfirm = !this.isConfirm;
    },
    handleChannelInput: function(channel) {
      let that = this;
      if (channel === CHANNEL.FAMILY) {
        this.familyModal = true;
      } else if (channel !== CHANNEL.SDL) {
        this.channel = channel;
      } else {
        this.channel = '';
        this.signCode = '';
        this.signCodeModal = true;
      }
    },

    handleStartPay: async function() {
      let that = this;
      that.$loading.show();
      that.payment = new Payment({
        orderId: that.order.id,
        channel: that.channel || CHANNEL.SDL,
        code: that.signCode,
        aliWapCb: function() {
          that.aliModal = true;
          that.$loading.hide();
        },
        wxQrCb: function(qr) {
          that.qr = qr;
          that.weChatModal = true;
          that.$loading.hide();
        },
        errCb: function(msg) {
          if (msg && !!msg) {
            Message({
              type: 'error',
              message: msg
            });
          }
          that.$loading.hide();
        },
        successCb: function() {
          that.success();
        }
      });
    },
    handleClickSuccess: function() {
      // window.location.href = '/pay/apply';
      this.$router.push({
        name: 'pay-admission-success'
      });
    },
    success: function() {
      this.$loading.hide();
      Message({
        type: 'success',
        message: '支付成功！'
      });

      this.$router.push({
        name: 'pay-admission-success'
      });
    },
    pathToSuccess: function() {
      // this.$router.push({
      //   name: 'student-pay-success'
      // });
      this.signCodeModal = false;
      this.weChatModal = false;
      this.aliModal = false;
      this.paid = true;
      let that = this;
      this.$nextTick(() => {
        that.$mountedRob();
      });
    },
    closeAliModal: function() {
      this.aliModal = false;
      if (this.payment) {
        this.payment.cleanListen();
      }
    },
    closeWeChatModal: function() {
      this.weChatModal = false;
      if (this.payment) {
        this.payment.cleanListen();
      }
    },
    // 付款 按钮 点击
    handleClickPay: async function() {
      let that = this;
      if (!this.isConfirm) {
        this.$message.error('请确认已了解退费政策');
        return;
      }
      if (that.channel && that.channel !== '') {
        if (that.channel !== CHANNEL.SDL) {
          await that.handleStartPay();
        } else if (that.payment) {
          that.payment.CodePay();
        }
      } else {
        Message({
          type: 'error',
          message: '请选择支付渠道'
        });
      }
    }
  }
};
</script>
